const state = {
  gdt: [],
};

const mutations = {
  SET_GDT_LABEL(state, value) {
    state.gdt = value;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
